const n = (o) => {
  const t = o.match(/T(\d{2}):(\d{2}):/);
  if (!t)
    throw new Error("Invalid date format");
  const r = t[1], e = t[2];
  return `${r}:${e}`;
};
export {
  n as getTimeFromDate
};
